export interface InvestmentInterest {
    id: number;
    entityId: number,
    entityName: string,
    investmentId: number,
    investmentShareClassificationId: number;
    shareClass: string;
    amount: number;
    shareCount: number | null;
    fundingMethod: number;
    fundingMethodDescription: string;
    accreditation: number;
    approved: boolean;
    fundingStatus: number;
    fundingStatusDescription: string;
}

export class InvestmentInterest implements InvestmentInterest {
    id: number = 0;
    entityId: number = 0;
    entityName: string = '';
    investmentId: number = 0;
    investmentShareClassificationId: number = 0;
    shareClassDescription: string = '';
    amount: number = 0.0;
    shareCount: number | null = null;
    fundingMethod: number = 0;
    fundingMethodDescription: string = '';
    accreditation: number = 0;
    approved: boolean = false;
    fundingStatus: number = 0;
    fundingStatusDescription: string = '';
    constructor(init?: InvestmentInterest) {
        Object.assign(this, init);
    }
}